import { render, staticRenderFns } from "./syncResult.vue?vue&type=template&id=8d2d50f2&scoped=true"
import script from "./syncResult.vue?vue&type=script&lang=js"
export * from "./syncResult.vue?vue&type=script&lang=js"
import style0 from "./syncResult.vue?vue&type=style&index=0&id=8d2d50f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d50f2",
  null
  
)

export default component.exports